import React from "react";

export const Tooltip = props => {
  if (props.tooltip) return <i className="info-icon tooltip tooltip-bottom tooltip-xs-right pl-1" data-tooltip={props.tooltip}></i>
  else return null
}
